<template>
  <v-btn @click.stop="onClick" text small>
    <v-icon id="RTE__command__imageButton">mdi-image</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'imageButton',
  methods: {
    onClick () {
      this.$emit('click', 'addImage')
    }
  }
}
</script>

<style scoped>
#RTE__command__imageButton {
  font-size: 20px;
}
</style>
